import React from "react";
import "./Container.css"; // Ensure this CSS file exists and is in the correct location

const SmallercontCareer = ({ children }) => {
  return <div className="smallercontcareer">{children}</div>;
};

export default SmallercontCareer;
